
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { POST } from "../../services/axiosInstance"; 
import {route} from "../../services/apiRoutes"

export const fetchCountries = createAsyncThunk(
  "countries/fetchCountries",
  async (_, thunkAPI) => {
    try {
      const res = await POST(
        route.GET_COUNTRY_LIST, {}); 
      
      if (res?.response?.success) {
        return res?.response?.response?.data?.countries || [];
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const countrySlice = createSlice({
  name: "countries",
  initialState: {
    countryList: [],
    isLoading: false,
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.countryList = action.payload;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload.error;
      });
  },
});

export default countrySlice.reducer;
